<template>
  <container-card
    id="filtrosPesquisarCentroCustos"
    icon="fa-filter"
    title="Selecione as opções de pesquisa."
  >
    <b-card>
      <CentrosCustosFormFilters :filters="filters" />

      <div slot="footer">
        <div class="float-left btn-pesquisar">
          <b-button
            style="width: 100px"
            @click.prevent="$emit('pesquisar')"
            variant="primary"
            size="sm"
            class="mr-2"
            :disabled="loading"
          >
            Pesquisar
          </b-button>
          <b-button
            style="width: 100px"
            @click.prevent="$emit('limpar')"
            size="sm"
            class="mr-2"
          >
            Limpar
          </b-button>
        </div>

        <div class="float-right btn-exportar">
          <el-popover
            placement="bottom"
            width="230"
            v-model="gerarRelatorioVisivel"
          >
            <p>Deseja gerar um relatório de Centros de Custos?</p>
            <div style="text-align: right; margin: 0">
              <el-button
                size="mini"
                type="text"
                @click="gerarRelatorioVisivel = false"
              >
                Não
              </el-button>
              <el-button
                type="primary"
                size="mini"
                @click="confirmarExportacao"
              >
                Sim
              </el-button>
            </div>
            <el-button
              style="width: 100px"
              type="success"
              slot="reference"
              size="small"
              :disabled="exportarDisabled"
            >
              <i class="fas fa-file-export"></i>
              Exportar
            </el-button>
          </el-popover>
        </div>
      </div>
    </b-card>
  </container-card>
</template>
<script>
import ContainerCard from "@/components/shared/ContainerCard";
import CentrosCustosFormFilters from "./widgets/form/CentrosCustosFormFilters.vue";

export default {
  name: "CentroCustosFilter",
  components: {
    ContainerCard,
    CentrosCustosFormFilters
  },
  props: {
    filters: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    exportarDisabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      gerarRelatorioVisivel: false
    };
  },
  methods: {
    confirmarExportacao() {
      this.$emit("exportar");
      this.gerarRelatorioVisivel = false;
    }
  }
};
</script>
